"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "event-chart"
  }, [_c("el-row", [_c("span", {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("Follow Up")]), _vm.isPersonSelectVisible ? _c("el-select", {
    attrs: {
      placeholder: "Select Person",
      clearable: "",
      size: "small"
    },
    on: {
      change: function ($event) {
        return _vm.handlePersonChange();
      }
    },
    model: {
      value: _vm.selectedAdminId,
      callback: function ($$v) {
        _vm.selectedAdminId = $$v;
      },
      expression: "selectedAdminId"
    }
  }, _vm._l(_vm.adminsList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.fullName,
        value: item.id
      }
    });
  }), 1) : _vm._e()], 1), _c("el-tabs", {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      type: "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    }
  }, [_c("el-tab-pane", {
    attrs: {
      label: `Open ${_vm.ongoingCount}`
    }
  }, [_c("el-table", {
    attrs: {
      data: _vm.list,
      border: "",
      "max-height": "320"
    }
  }, [_c("el-table-column", {
    attrs: {
      width: "60",
      align: "center",
      label: "ID"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/follow-ups/list/" + scope.row.leadId
          }
        }, [_c("el-link", {
          attrs: {
            type: "danger"
          }
        }, [_vm._v(" # " + _vm._s(scope.row.id) + " ")])], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Client Name",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/follow-ups/list/" + scope.row.leadId
          }
        }, [_vm._v(" " + _vm._s(scope.row.lead.client.name) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Task"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/follow-ups/list/" + scope.row.leadId
          }
        }, [_vm._v(" " + _vm._s(_vm.agendaLabels[scope.row.agenda] || scope.row.agenda) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Assign to",
      width: "160",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/follow-ups/list/" + scope.row.leadId
          }
        }, [_vm._v(" " + _vm._s(scope.row.assignedUser.fullName) + " "), _c("br"), _vm._v(" Due Dt.- " + _vm._s(_vm._f("moment")(scope.row.dueDate, "DD MMMM YYYY")) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Priority",
      width: "90",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/follow-ups/list/" + scope.row.leadId
          }
        }, [_c("el-tag", {
          attrs: {
            type: _vm.tagType[scope.row.priority]
          }
        }, [_vm._v(" " + _vm._s(scope.row.priority) + " ")])], 1)];
      }
    }])
  })], 1)], 1), _c("el-tab-pane", {
    attrs: {
      label: `Missed ${_vm.missedCount}`
    }
  }, [_c("el-table", {
    attrs: {
      data: _vm.list,
      border: "",
      "max-height": "320"
    }
  }, [_c("el-table-column", {
    attrs: {
      width: "60",
      align: "center",
      label: "ID"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/follow-ups/list/" + scope.row.leadId
          }
        }, [_c("el-link", {
          attrs: {
            type: "danger"
          }
        }, [_vm._v(" # " + _vm._s(scope.row.id) + " ")])], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Client Name",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/follow-ups/list/" + scope.row.leadId
          }
        }, [_vm._v(" " + _vm._s(scope.row.lead.client.name) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Task"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/follow-ups/list/" + scope.row.leadId
          }
        }, [_vm._v(" " + _vm._s(_vm.agendaLabels[scope.row.agenda] || scope.row.agenda) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Assign to",
      width: "160",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/follow-ups/list/" + scope.row.leadId
          }
        }, [_vm._v(" " + _vm._s(scope.row.assignedUser.fullName) + " "), _c("br"), _vm._v(" Due Dt.- " + _vm._s(_vm._f("moment")(scope.row.dueDate, "DD MMMM YYYY")) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Priority",
      width: "90",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/follow-ups/list/" + scope.row.leadId
          }
        }, [_c("el-tag", {
          attrs: {
            type: _vm.tagType[scope.row.priority]
          }
        }, [_vm._v(" " + _vm._s(scope.row.priority) + " ")])], 1)];
      }
    }])
  })], 1)], 1), _c("el-tab-pane", {
    attrs: {
      label: `Upcoming ${_vm.upcomingCount}`
    }
  }, [_c("el-table", {
    attrs: {
      data: _vm.list,
      border: "",
      "max-height": "320"
    }
  }, [_c("el-table-column", {
    attrs: {
      width: "60",
      align: "center",
      label: "ID"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/follow-ups/list/" + scope.row.leadId
          }
        }, [_c("el-link", {
          attrs: {
            type: "danger"
          }
        }, [_vm._v(" # " + _vm._s(scope.row.id) + " ")])], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Client Name",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/follow-ups/list/" + scope.row.leadId
          }
        }, [_vm._v(" " + _vm._s(scope.row.lead.client.name) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Task"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/follow-ups/list/" + scope.row.leadId
          }
        }, [_vm._v(" " + _vm._s(_vm.agendaLabels[scope.row.agenda] || scope.row.agenda) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Assign to",
      width: "160",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/follow-ups/list/" + scope.row.leadId
          }
        }, [_vm._v(" " + _vm._s(scope.row.assignedUser.fullName) + " "), _c("br"), _vm._v(" Due Dt.- " + _vm._s(_vm._f("moment")(scope.row.dueDate, "DD MMMM YYYY")) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Priority",
      width: "90",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/follow-ups/list/" + scope.row.leadId
          }
        }, [_c("el-tag", {
          attrs: {
            type: _vm.tagType[scope.row.priority]
          }
        }, [_vm._v(" " + _vm._s(scope.row.priority) + " ")])], 1)];
      }
    }])
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;